import React, { useEffect } from 'react';
import { AutoHeightInput } from 'src/domains/players/webview/components/Account/traderChat/components/AutoHeightInput';
import { observer } from 'src/utils/mobx-react';
import { ChatWritingAreaForm, ChatWritingAreaBtn, SendIconWrapper } from './ChatInput.style';
import { useCommon } from 'src/domains/common/Common';
import { TraderChatState } from 'src/domains/players/state/traderChat/TraderChatState';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { UniverseComponent } from 'src/domains/common/universes';

export const ChatInput = observer('ChatInput', () => {
    const common = useCommon();
    const { isNightModeEnabled, handleSubmitMessage, clearMessage, stopTyping } = TraderChatState.get(common);
    const configState = ConfigComponents.get(common).config;

    useEffect(() => {
        return (): void => {
            stopTyping();
            clearMessage();
        };
    }, []);

    if (isNightModeEnabled === true) {
        return null;
    }

    const { traderChatVariant } = configState.componentVariants;

    return (
        <ChatWritingAreaForm
            onSubmit={handleSubmitMessage}
            traderChatVariant={traderChatVariant}
        >
            <AutoHeightInput />
            <ChatWritingAreaBtn
                size='small'
                type='submit'
                dataTest='send-button'
            >
                {traderChatVariant === DefaultComponentVariantType.SECONDARY ? (
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.chatInputIcon />}
                    </UniverseComponent>
                ) : (
                    <SendIconWrapper />
                )}
            </ChatWritingAreaBtn>
        </ChatWritingAreaForm>
    );
});
